// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 此处后端没有提供注释 GET /admin/dashboard */
export async function adminControllerGetDashboard(options?: {
  [key: string]: any;
}) {
  return request<any>("/admin/dashboard", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /admin/login */
export async function adminControllerLogin(
  body: API.AdminLoginDto,
  options?: { [key: string]: any }
) {
  return request<API.AdminLoginResponseDto>("/admin/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /admin/logout */
export async function adminControllerLogout(options?: { [key: string]: any }) {
  return request<boolean>("/admin/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 管理员手机号登录 POST /admin/login/sms */
export async function adminControllerLoginWithSms(
  body: API.AdminSmsLoginDto,
  options?: { [key: string]: any }
) {
  return request<API.AdminLoginResponseDto>("/admin/login/sms", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 发送管理员登录验证码 POST /admin/sms/send/login */
export async function adminControllerSendLoginSmsCode(
  body: API.SmsCodeDto,
  options?: { [key: string]: any }
) {
  return request<boolean>("/admin/sms/send/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /admin/stats */
export async function adminControllerGetStats(options?: {
  [key: string]: any;
}) {
  return request<any>("/admin/stats", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /admin/users */
export async function adminControllerGetUsers(options?: {
  [key: string]: any;
}) {
  return request<any>("/admin/users", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取系统状态 GET /admin/system-status */
export async function adminControllerGetSystemStatus(options?: {
  [key: string]: any;
}) {
  return request<API.SystemStatusDto>("/admin/system-status", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取用户注册趋势数据 GET /admin/trends/user */
export async function adminControllerGetUserTrends(
  params: {
    startDate?: string;
    endDate?: string;
    period?: "day" | "month" | "year";
  },
  options?: { [key: string]: any }
) {
  return request<API.UserCountByDto[]>("/admin/trends/user", {
    method: "GET",
    params,
    ...(options || {}),
  });
}

/** 获取支付趋势数据 GET /admin/trends/payment */
export async function adminControllerGetPaymentTrends(
  params: {
    startDate?: string;
    endDate?: string;
    period?: "day" | "month" | "year";
  },
  options?: { [key: string]: any }
) {
  return request<API.AmountByDto[]>("/admin/trends/payment", {
    method: "GET",
    params,
    ...(options || {}),
  });
}

/** 获取趋势数据 GET /admin/trends (已废弃，请使用 adminControllerGetUserTrends 或 adminControllerGetPaymentTrends) */
export async function adminControllerGetTrends(
  params: {
    period?: "day" | "week" | "month";
    days?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.TrendDataDto[]>("/admin/trends", {
    method: "GET",
    params,
    ...(options || {}),
  });
}

// ==================== 用户管理接口 ====================

/** 分页查询用户列表 GET /admin/user/list */
export async function adminUserControllerGetUserList(
  params: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: "ASC" | "DESC";
    [key: string]: any;
  },
  options?: { [key: string]: any }
) {
  return request<{
    data: API.UserInfoResponseDto[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  }>("/admin/user/list", {
    method: "GET",
    params,
    ...(options || {}),
  });
}

/** 新建用户 POST /admin/user/create */
export async function adminUserControllerCreateUser(
  body: API.AdminCreateUserDto,
  options?: { [key: string]: any }
) {
  return request<API.UserInfoResponseDto>("/admin/user/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 重置用户密码 POST /admin/user/reset-password */
export async function adminUserControllerResetUserPassword(
  body: API.AdminResetPasswordDto,
  options?: { [key: string]: any }
) {
  return request<{ message: string }>("/admin/user/reset-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 绑定用户手机号码 POST /admin/user/bind-phone */
export async function adminUserControllerBindUserPhone(
  body: API.AdminBindPhoneDto,
  options?: { [key: string]: any }
) {
  return request<{ message: string }>("/admin/user/bind-phone", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 修改用户信息 PUT /admin/user/update */
export async function adminUserControllerUpdateUser(
  body: API.AdminUpdateUserDto,
  options?: { [key: string]: any }
) {
  return request<API.UserInfoResponseDto>("/admin/user/update", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 查看用户购买的会员情况 GET /admin/membership/user/:userId */
export async function adminUserControllerGetUserMembership(
  userId: number,
  options?: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: string;
    search?: string;
    searchFields?: string;
    isActive?: boolean;
    [key: string]: any;
  }
) {
  const params = new URLSearchParams();
  if (options?.page) params.append("page", options.page.toString());
  if (options?.pageSize) params.append("pageSize", options.pageSize.toString());
  if (options?.sortBy) params.append("sortBy", options.sortBy);
  if (options?.sortOrder) params.append("sortOrder", options.sortOrder);
  if (options?.search) params.append("search", options.search);
  if (options?.searchFields)
    params.append("searchFields", options.searchFields);
  if (options?.isActive !== undefined)
    params.append("isActive", options.isActive.toString());

  const { memberships, ...pagination } = await request<{
    memberships: any[];
    pagination: {
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
      hasNext: boolean;
      hasPrev: boolean;
      startIndex: number;
      endIndex: number;
    };
  }>(`/admin/user/${userId}/membership?${params.toString()}`, {
    method: "GET",
    ...(options || {}),
  });

  // 转换数据格式以匹配前端期望的格式
  return {
    data: memberships.map((membership) => ({
      id: membership.id,
      type:
        membership.boughtTier?.name ||
        membership.boughtTier?.description ||
        "未知",
      level: membership.boughtTier?.tierType || "未知",
      startDate: membership.startDate,
      endDate: membership.endDate,
      isValid:
        membership.status === "active" &&
        new Date(membership.endDate) > new Date(),
      status: membership.status,
      amount: membership.boughtTier?.price || 0,
      purchaseDate: membership.createdAt,
      remainingTokens: membership.remainingTokens,
      totalTokens: membership.totalTokens,
      consumptionPriority: membership.consumptionPriority,
    })),
    pagination,
  };
}

/** 删除用户（软删除） POST /admin/user/delete */
export async function adminUserControllerDeleteUser(
  body: { userId: number },
  options?: { [key: string]: any }
) {
  return request<{ message: string }>("/admin/user/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 取消用户会员 POST /admin/user/membership/cancel */
export async function adminUserControllerCancelMembership(
  body: { userId: number; membershipId: number },
  options?: { [key: string]: any }
) {
  return request<{ message: string }>("/admin/user/membership/cancel", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: body,
    ...(options || {}),
  });
}

/** 给用户捐赠会员 POST /admin/user/membership/donate */
export async function adminUserControllerDonateMembership(
  body: { userId: number; membershipTierId: number; reason?: string },
  options?: { [key: string]: any }
) {
  return request<{ message: string; paymentId: string }>(
    "/admin/user/membership/donate",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取所有可用的会员等级 GET /admin/user/membership/tiers */
export async function adminUserControllerGetMembershipTiers(options?: {
  [key: string]: any;
}) {
  return request<API.MembershipTierDto[]>("/admin/user/membership/tiers", {
    method: "GET",
    ...(options || {}),
  });
}

/** 修改当前登录管理员密码 POST /admin/change-password */
export async function adminControllerChangePassword(
  body: API.ChangePasswordDto,
  options?: { [key: string]: any }
) {
  return request<boolean>("/admin/change-password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
